module.exports = __webpack_public_path__ + "static/media/room1.84573192.jpg";